import { clearRegistrationProgress } from '../../registration/services/registration.storage.service';
import { clearTrainingProgress } from '../../training/services/questionnaire.storage.service';

const ONBOARDING_TOKEN_KEY = 'onboarding_token';

export function clearOnboardingStorage() {
  try {
    localStorage.removeItem(ONBOARDING_TOKEN_KEY);
  } catch {}

  clearRegistrationProgress();
  clearTrainingProgress();
}
